<template>
  <header class="mobile-header" :class="{ 'menu-open': isMenuOpen, 'is-subpage': isSubpage }">
    <!-- 상단 헤더 바 -->
    <div class="header-bar">
      <div class="header-inner">
        <!-- 로고 -->
        <router-link to="/" class="logo" @click="closeMenu">
          <span class="logo-text-header">청주 레이원시티<br/>홍보관 상담센터</span>
        </router-link>

        <!-- 전화 아이콘 + 메뉴버튼 -->
        <div class="header-right">
          <a href="tel:1666-6818" class="phone-btn" aria-label="전화하기">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            <span class="phone-number">1666-6818</span>
          </a>
          <button class="menu-toggle" @click="toggleMenu" aria-label="메뉴 열기">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </div>

    <!-- 풀스크린 메뉴 -->
    <div class="mobile-menu" :class="{ 'is-open': isMenuOpen }">
      <div class="menu-bg"></div>
      <div class="menu-content">
        <!-- 상단: 전화번호 -->
        <div class="menu-header">
          <a href="tel:1666-6818" class="menu-phone">
            <span class="number">1666-6818</span>
          </a>
        </div>

        <!-- 메뉴 리스트 -->
        <nav class="menu-nav">
          <div
            v-for="(menu, index) in menuData"
            :key="index"
            class="menu-group"
            :style="{ '--delay': `${0.1 + index * 0.05}s` }"
          >
            <button
              class="menu-title"
              :class="{ 'is-open': openMenuIndex === index }"
              @click="toggleSubMenu(index)"
            >
              {{ menu.title }}
              <span class="arrow">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </span>
            </button>
            <ul class="sub-menu" :class="{ 'is-open': openMenuIndex === index }">
              <li v-for="(sub, subIndex) in menu.children" :key="subIndex">
                <router-link :to="sub.path" @click="closeMenu">
                  {{ sub.title }}
                </router-link>
              </li>
            </ul>
          </div>
        </nav>

        <!-- 하단: 로고 -->
        <div class="menu-footer">
          <div class="footer-logo">
            <span class="logo-main">청주 레이원시티 홍보관 상담센터</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader',
  computed: {
    isSubpage() {
      return this.$route.path !== '/'
    }
  },
  data() {
    return {
      isMenuOpen: false,
      openMenuIndex: null,
      menuData: [
        {
          title: '사업소개',
          children: [
            { title: '사업개요', path: '/intro/overview' },
            { title: '브랜드', path: '/intro/brand' }
          ]
        },
        {
          title: '입지안내',
          children: [
            { title: '입지환경', path: '/location/environment' }
          ]
        },
        {
          title: '상품안내',
          children: [
            { title: '단지정보', path: '/product/complex' },
            { title: '프리미엄', path: '/product/premium' },
            { title: '커뮤니티', path: '/product/community' }
          ]
        },
        {
          title: '타입안내',
          children: [
            { title: '59㎡', path: '/type/59' },
            { title: '74㎡', path: '/type/74' },
            { title: '84㎡A', path: '/type/84A' },
            { title: '84㎡A-1', path: '/type/84A-1' },
            { title: '84㎡B', path: '/type/84B' }
          ]
        },
        {
          title: '홍보센터',
          children: [
            { title: '홍보영상', path: '/media/video' }
          ]
        },
        {
          title: '방문예약',
          children: [
            { title: '관심고객등록', path: '/reservation/register' }
          ]
        }
      ]
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      document.body.style.overflow = this.isMenuOpen ? 'hidden' : ''
      if (!this.isMenuOpen) {
        this.openMenuIndex = null
      }
    },
    closeMenu() {
      this.isMenuOpen = false
      this.openMenuIndex = null
      document.body.style.overflow = ''
    },
    toggleSubMenu(index) {
      this.openMenuIndex = this.openMenuIndex === index ? null : index
    }
  }
}
</script>

<style scoped>
/* 헤더 바 */
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-bar {
  background: var(--rayone-primary);
  transition: background 0.3s ease;
}

.header-inner {
  padding: 0 20px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 로고 */
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-text-header {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.3px;
  line-height: 1.4;
}

/* 헤더 우측 */
.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* 전화 버튼 */
.phone-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.phone-btn:active {
  background: #fff;
  color: var(--rayone-primary);
}

.phone-number {
  font-family: var(--font-paperlogy);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* 메뉴 토글 버튼 */
.menu-toggle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 28px;
  height: 28px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.menu-toggle span {
  display: block;
  width: 100%;
  height: 2px;
  background: #fff;
  transition: all 0.3s ease;
  transform-origin: center;
}

.menu-open .menu-toggle span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.menu-open .menu-toggle span:nth-child(2) {
  opacity: 0;
}

.menu-open .menu-toggle span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* 풀스크린 메뉴 */
.mobile-menu {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease;
}

.mobile-menu.is-open {
  opacity: 1;
  visibility: visible;
}

.menu-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #112238 0%, #091525 100%);
  transform: translateY(-100%);
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu.is-open .menu-bg {
  transform: translateY(0);
}

.menu-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px 24px;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease 0.2s;
}

.mobile-menu.is-open .menu-content {
  opacity: 1;
  transform: translateY(0);
}

/* 메뉴 상단 */
.menu-header {
  margin-bottom: 30px;
}

.menu-phone {
  display: inline-block;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 12px 24px;
  border-radius: 30px;
}

.menu-phone .number {
  font-family: var(--font-paperlogy);
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
}

/* 메뉴 네비게이션 */
.menu-nav {
  flex: 1;
  overflow-y: auto;
}

.menu-group {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease;
  transition-delay: var(--delay);
}

.mobile-menu.is-open .menu-group {
  opacity: 1;
  transform: translateY(0);
}

.menu-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 18px 0;
  background: none;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  text-align: left;
}

.menu-title .arrow {
  transition: transform 0.3s ease;
}

.menu-title.is-open .arrow {
  transform: rotate(180deg);
}

/* 서브메뉴 */
.sub-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.sub-menu.is-open {
  max-height: 300px;
  padding-bottom: 16px;
}

.sub-menu li {
  padding: 0;
}

.sub-menu a {
  display: block;
  padding: 12px 0 12px 16px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.sub-menu a:active {
  color: #fff;
}

/* 메뉴 하단 */
.menu-footer {
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}

.footer-logo {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.footer-logo .logo-main {
  font-family: var(--font-paperlogy);
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
}

</style>
